module.exports = __webpack_public_path__ + "static/media/edu-fair-mob.b7aafd12.svg";